import { useCallback, useState, useEffect } from "react";
import iconProfile from "../assets/FamilyIcons/humanoid.png";
import axios from "axios";
function Feedback() {
  const [fields, setFields] = useState({ user: "", title: "", message: "" });
  const [errors, setErrors] = useState({ user: "", title: "", message: "" });
  const [feedbackList, setFeedbackList] = useState({ data: [], loading: true });
  const [submitLoading, setSubmitLoading] = useState(false);
  const handleInputChange = useCallback((event) => {
    let updatedValue = {};
    updatedValue = { [event.target.name]: event.target.value };
    setFields((fields) => ({
      ...fields,
      ...updatedValue,
    }));
  });
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = useCallback(async () => {
    await axios
      .get("https://apipetslaravel.herokuapp.com/api/getFeedback", {
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
      })
      .then((response) => {
        let result = Object.keys(response.data).map((key) => [
          key,
          response.data[key],
        ]);
        setFeedbackList({ data: result, loading: false });
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const submit = useCallback(() => {
    for (var name in fields) {
      checkField(name);
    }
    const validate = Object.values(fields).every((value) => {
      if (value !== "") {
        return true;
      }

      return false;
    });
    if (validate) {
      // Submit data
      addFeedback();
    }
  });
  const addFeedback = useCallback(async () => {
    setSubmitLoading(true);
    await axios
      .post("https://apipetslaravel.herokuapp.com/api/addFeedback", fields, {
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
      })
      .then((response) => {
        if (response.data.success) {
          fetchData();
        }
        setSubmitLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setSubmitLoading(false);
      });
  }, [fields]);
  const checkField = (fieldName) => {
    if (fields[fieldName] === "") {
      let updatedValue = {};
      updatedValue = { [fieldName]: fieldName + " is required" };
      setErrors((errors) => ({
        ...errors,
        ...updatedValue,
      }));
    } else {
      let updatedValue = {};
      updatedValue = { [fieldName]: "" };
      setErrors((errors) => ({
        ...errors,
        ...updatedValue,
      }));
    }
  };
  return (
    <div className="FeedbackPage">
      <div>
        <h3>Feedback Page coming soon.</h3>
        {feedbackList.loading ? (
          <div className="loadingSpinner"></div>
        ) : (
          <div className="messageList">
            {feedbackList.data[0]?.[0] === "Empty" ? (
              <h4>No Feedback Yet</h4>
            ) : (
              feedbackList.data.map((feedback, index) => (
                <div className="messageBox" key={index}>
                  <div className="detailsMessage">
                    <p className="user">User: {feedback[1].user}</p>
                    <p className="date">{feedback[1].time_stamp}</p>
                  </div>
                  <img src={iconProfile} title="profilePic" />
                  <p className="titleMessage">{feedback[1].title}</p>
                  <p className="message">{feedback[1].message}</p>
                </div>
              ))
            )}
          </div>
        )}
      </div>
      <div className="createMessage">
        <h4>Feedback.</h4>
        <p>Please write your suggestions here...</p>
        <div className="titleUserMessage">
          <div className="inputFlex">
            <label>
              User<div className="required">*</div>{" "}
            </label>
            <div className="error_required">{errors.user}</div>
            <input
              name="user"
              onChange={handleInputChange}
              placeholder="User..."
            />
          </div>
          <div className="inputFlex">
            <label>
              Title<div className="required">*</div>{" "}
            </label>
            <div className="error_required">{errors.title}</div>
            <input
              name="title"
              onChange={handleInputChange}
              placeholder="Title..."
            />
          </div>
        </div>
        <textarea
          name="message"
          onChange={handleInputChange}
          placeholder="Write your message here..."
        />
        <div className="error_required">{errors.message}</div>
        <button
          className={submitLoading ? "disabled" : ""}
          disabled={submitLoading}
          onClick={submit}
        >
          {submitLoading ? "Loading" : "Send"}
        </button>
      </div>
    </div>
  );
}

export default Feedback;
